import { ISnackbarPrompt } from './types';
import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_BUTTON_CANCEL, SNACKBAR_BUTTON_START } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { snackbarPromtDefault } from './promtDefault';

export const snackbarPromtStartCancel = (
    options: ISnackbarPrompt
) => {
    return (dispatch: Dispatch) => {
        options.buttons = [
            {
                onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionCancel)),
                text: SNACKBAR_BUTTON_CANCEL
            },
            {
                onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionApply)),
                isPrimary: true,
                text: SNACKBAR_BUTTON_START
            },
        ];
        dispatch(snackbarPromtDefault(options));
    }
};
